import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static values = {
    isOpened: { type: Boolean, default: false }
  }

  static targets = ['card']

  connect () {
    useClickOutside(this, { element: this.cardTarget })
  }

  isOpenedValueChanged (value) {
    if (value === true) {
      this.cardTarget.classList.add('mentor_card-opened')
    } else {
      this.cardTarget.classList.remove('mentor_card-opened')
    }
  }

  open () {
    this.isOpenedValue = true
  }

  close () {
    this.isOpenedValue = false
  }

  clickOutside (event) {
    if (this.isOpenedValue === true) {
      event.preventDefault()
      this.isOpenedValue = false
    }
  }
}
